import React, {Component} from "react";
import {connect} from "react-redux";
import Table from "../../components/Table";
import OrderItem from "./OrderItem";
import GraphQLErrors from "../../components/GraphQLErrors";
import {fromJS} from "immutable";
import {graphql} from "react-apollo";
import {LIST_ORDERS} from "../../queries/sales";
import {requestViewChargePayments} from "../../actions/AccountApiActions";
import PaginatorButton from "../../components/PaginatorButton";
import withFiltersAndSorting, {SORTING_DIRECTIONS} from "../../lib/WithFiltersAndSorting";

class OrderList extends Component {

  // UNSAFE_componentWillMount() {
  //   this.subscribe(this.props.orderId); 
  // }

  // subscribe(orderId) {
  //   if (this.unsubscribe) {
  //     this.unsubscribe();
  //   }
  //   this.unsubscribe = this.props.subscribeToUpdates(this.props, {});
  // } 

  render() {
    let {loading, error, salesOrders} = this.props.data;

    if (error) return <GraphQLErrors error={error} />

    // While content is loading we set data as empty array
    const salesOrdersData = fromJS(salesOrders || []);

    return (
      <div>
        <Table
          loading={loading}
          data={salesOrdersData.get("entries")}
          renderer={(props) => <OrderItem {...props} advancedMode={this.props.advancedMode} />}
          tableHeader={this.props.tableColumns}
          // createFilteringInput={this.props.createFilteringInput}
          createSortingArrows={this.props.createSortingArrows}
          onItemClick={this.handleItemClick.bind(this)}
          extraClassName="OrderList"
          itemKey="orderId"
          mode="table"
          selected={this.props.selectedId}
          showCount={true}
          onContextMenuClick={this.handleContextMenuClick.bind(this)}
          />
        <PaginatorButton
          metadata={salesOrdersData.get("metadata")}
          onNext={this.handleNext.bind(this)}
          />
      </div>
    );
  }

  handleNext(afterId) {
    this.props.data.fetchMore({
      variables: {
        pagination: {
          after: afterId
        }
      },
      updateQuery: (prev, {fetchMoreResult}) => {
        if (!fetchMoreResult) return prev;
        return {
          salesOrders: {
            __typename: prev.salesOrders.__typename,
            metadata: fetchMoreResult.salesOrders.metadata,
            entries: [...prev.salesOrders.entries, ...fetchMoreResult.salesOrders.entries]
          }
        }
      }
    })
  }

  handleItemClick(itemData, e, field = "") {
    let id = itemData.get("orderId");
    if (field === "id") {
      e.stopPropagation();
      this.props.onIdClick(id);
      return;
    }    
    this.props.onSelectionChange(id);
  }  

  handleContextMenuClick(accountId, orderId) {
    this.props.requestViewChargePayments(accountId, orderId);
  }
}


const withSubscription = connect(null, {requestViewChargePayments});

const withQuery = graphql(LIST_ORDERS, {
  options: (props) => ({
    fetchPolicy: "network-only",
    variables: {
      filter: {
        ...props.filters,
        shopId: props.shopFilter,
        billingStatus: props.billingStatusFilter,
        type: props.typeFilter,
        invoiceNr: props.invoiceNrSearch,
        orderId: props.orderIdSearch,
        shippingName: props.shippingNameSearch,
        billingName: props.billingNameSearch,
        promoCode: props.promoCodeSearch,
      },
      sortOrders: props.sortOrders,
    }
  })
})

export default withFiltersAndSorting(withQuery(withSubscription(OrderList)), {
  tableColumns: (props) => {
    const columns = [
      { title: "Invoice #" },
      { title: "Billing Name" },
      { title: "Created Date" },
      { title: "Paid Date" },
      { title: "Total" },
      { title: "Billing Status" },
      { title: "" },
      { title: "" },
    ];

    if (props.advancedMode) {
      columns.splice(2, 0, { title: "Recipient name" });
      columns.splice(6, 0, { title: "Discount" });
    }
    return columns;
  },
  defaultSortings: [{name: "created_at", direction: SORTING_DIRECTIONS.DESC}, {name: "order_id", direction: SORTING_DIRECTIONS.ASC}],
})